import React from 'react';
import Products from '../../utils/tabs/products/Products';

/**
 * Affiche le composant d'information sur le destinataire du colis dans le drawer
 * de la section expéditions
 */
const ProductsTab = () => (
  <div>
    <Products />
  </div>
);

export default ProductsTab;
